import React from 'react';
import cookie from 'react-cookies';
import { LoadingOutlined } from '@ant-design/icons';
import portrait from '../../../imges/securityStaff/portrait.png';
import Modal from './Modal';
import ImgModal from './ImgModal';
import Toast from '../../../component/toast';
import API from '../../../server/index';
import './style/index.less';

export default function () {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [inputVal, setInputVal] = React.useState<string>('');
  const [showModal, setShowModal] = React.useState<boolean>(false);
  const [showResult, setShowResult] = React.useState<boolean>(false);
  const [defaultMsg, setDefaultMsg] = React.useState<string>('');
  const [resultList, setResultList] = React.useState<any[]>([
    // { nickName: '显示', realName: 'ww', mobile: '283****3456', position: '餐品专家', isLeave: false },
    // { nickName: '显示', realName: 'ww', mobile: '283****3456', position: '餐品专家', isLeave: true },
  ]);
  const [imgShow, setImageShow] = React.useState({ visible: false, src: '' });

  // 搜索员工
  const searchEmployees = async () => {
    setShowResult(false);
    if (!inputVal.trim().length) {
      Toast('请输入遥望员工花名/真实姓名/手机号');
      return
    }
    const tmpToken = sessionStorage.getItem('tmpToken');
    if (!tmpToken) {
      setShowModal(true);
    } else {
      if (loading) return;
      setLoading(true);
      try {
        const res = await API.ApiEmployeeQuery28875({
          key: inputVal.trim(),
          tmpToken
        })
        setLoading(false);
        setShowResult(true);
        setDefaultMsg(res?.data?.defaultMsg || '');
        setResultList(res?.data?.employeeInfoList || []);
      } catch (error) {
        setLoading(false);
        if (error?.code === '20133') { // token
          setShowModal(true);
          sessionStorage.removeItem('tmpToken');
        }
      }
    }
  }

  return (
    <div className="securityStaff-index">
      <div className="center-wrap">
        <h1>遥望员工防伪查询</h1>
        {/* 输入框 */}
        <div className="input-wrap">
          <input
            type='text'
            value={inputVal}
            maxLength={11}
            id="securityStaffInput"
            autoComplete='off'
            placeholder="请输入遥望员工花名/真实姓名/手机号"
            onChange={(e)=> setInputVal(e.target.value)}
          />
          <div className="button" onClick={searchEmployees}>
            {loading ? <LoadingOutlined /> : <i />}
          </div>
        </div>
        {/* 结果展示 */}
        {showResult && (
          <div className="result-wrap">
            <p>查询结果：</p>
            {resultList.length ? (
              <div className="result-list">
                {resultList.map((item, index) => (
                  <div key={index} className={['result-item', !item.isLeave ? 'employees' : 'departure'].join(' ')}>
                    <img
                      className={item.iconUrl ? 'click' : ''}
                      src={item.iconUrl || portrait}
                      alt="employees_img"
                      onClick={() => {
                        if (item.iconUrl) {
                          setImageShow({ visible: true, src: item.iconUrl })
                        }
                      }}
                    />
                    <div className="middle-area">
                      <h3>{`${item.nickName}(${item.realName})`}</h3>
                      <p>
                        {item.position && <span className="gray">{item.position}</span>}
                        <span>{item.mobile}</span>
                      </p>
                    </div>
                    <div className="right-area">
                      <i />
                      {!item.isLeave ? '认证员工' : '已离职'}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div
                className="empty-wrap"
                dangerouslySetInnerHTML={{
                  __html: defaultMsg,
                }}
              />
            )}
          </div>
        )}
      </div>
      <Modal
        visible={showModal}
        close={(isLogin) => {
          setShowModal(false);
          if (isLogin) {
            searchEmployees();
          }
        }}
      />
      <ImgModal {...imgShow} close={() => setImageShow({ visible: false, src: '' })} />
    </div>
  )
}

